// Sub-modal de cadastro rápido de centro de custo INDIRETO (estrutural) —
// mesmo padrão do ModalNovoFornecedor. Os centros de CONTRATO (projeto,
// P_NNNNN) nascem automáticos ao iniciar o contrato; aqui só o eixo de
// indiretas (Escritório, Eventos, Frota...). Pedido do Lucas 2026-07-20.
import { useState } from 'react';
import axios from 'axios';
import { Modal, Form, Input, Typography, App as AntApp } from 'antd';
import { API_URL } from '../../config';
import { getToken } from './utils';

const { Text } = Typography;

export function ModalNovoCentroCusto({ onFechar, onCriou }: {
  onFechar: () => void;
  onCriou: (codigo: string) => void;
}) {
  const { message } = AntApp.useApp();
  const [nome, setNome] = useState('');
  const [salvando, setSalvando] = useState(false);

  async function salvar() {
    if (!nome.trim()) { message.warning('Informe o nome do centro de custo'); return; }
    setSalvando(true);
    try {
      const token = await getToken();
      // rota via greedy /financeiro/{proxy+} (sem recurso novo no API Gateway)
      const r = await axios.post(`${API_URL}/financeiro/centros-custo`,
        { nome: nome.trim() }, { headers: { Authorization: token } });
      const d = r.data.body ? JSON.parse(r.data.body) : r.data;
      message.success('Centro de custo criado.');
      onCriou(d.codigo_canonical);
    } catch (e: any) {
      message.error('Erro: ' + (e.response?.data?.erro || e.response?.data?.error || e.message));
    } finally { setSalvando(false); }
  }

  return (
    <Modal open onCancel={onFechar} onOk={salvar} confirmLoading={salvando} width={440} destroyOnClose
      centered title="+ Novo centro de custo (indireta)" okText="Criar" cancelText="Cancelar">
      <Form layout="vertical" size="small">
        <Form.Item label="Nome" required
          extra={<Text type="secondary" style={{ fontSize: 11 }}>
            Só pra centros de <strong>indiretas</strong> (Escritório, Eventos, Frota…).
            Os centros de contrato (P_NNNNN) são criados automaticamente junto com o contrato.
          </Text>}>
          <Input value={nome} onChange={(e) => setNome(e.target.value)}
            placeholder="ex: Frota" onPressEnter={salvar} autoFocus />
        </Form.Item>
      </Form>
    </Modal>
  );
}
